import { render, staticRenderFns } from "./SalesView.vue?vue&type=template&id=04a6267c&scoped=true"
import script from "./SalesView.vue?vue&type=script&lang=js"
export * from "./SalesView.vue?vue&type=script&lang=js"
import style0 from "./SalesView.vue?vue&type=style&index=0&id=04a6267c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6267c",
  null
  
)

export default component.exports